import NovedadesPage from './NovedadesPage.jsx';

export default function NovedadesRetenidasPage() {
  return <NovedadesPage onlyRetenidas />;
}
